import React, { useContext, useEffect, useState } from "react";
import "./FBOHome.css";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "../../utils/routePaths";
import FeesCard from "../../components/element/FeesCard";
import NavigationBar from "../../components/element/NavigationBar";
import { StorageContext } from "../../services/StorageProvider";
import { getServiceUrls } from "../../services/serviceUrls";
import VersioningComponent from "./Views/VersioningComponent";
import VersionNotification from "../../components/element/VersionNotification";
import { FBO_ROLE_CODES } from "../../utils/constants";

const FBOHome = () => {
  const navigate = useNavigate();
  const { fboUserProfileData } = useContext(StorageContext);
  const [enabledFeeTypes, setEnabledFeeTypes] = useState([]);
  const [hasAdminAccess, setHasAdminAccess] = useState(false);
  const SERVICE_URL = getServiceUrls();
  const [isVersionDialogOpen, setIsVersionDialogOpen] = useState(false);
  const [showVersionModal, setShowVersionModal] = useState(false);

  useEffect(() => {
    if (fboUserProfileData) {
      if (fboUserProfileData?.associations?.length) {
        setHasAdminAccess(
          fboUserProfileData?.associations[0]?.role !== FBO_ROLE_CODES.FBO_EMPLOYEE
        );
        setEnabledFeeTypes((prev) => {
          const newFeeTypes = new Set(prev);
          fboUserProfileData?.associations.forEach((item) => {
            if (item?.fboCustomer?.landingFeeEnabled)
              newFeeTypes.add("landingFee");
            if (item?.fboCustomer?.fuelRoyaltyEnabled)
              newFeeTypes.add("fuelRoyalty");
            if (item?.fboCustomer?.landLeaseEnabled)
              newFeeTypes.add("landLease");
          });
          return prev.length === newFeeTypes.size
            ? prev
            : Array.from(newFeeTypes);
        });
      }
    }
  }, [fboUserProfileData, enabledFeeTypes]);
  const handleVersionClick = () => {
    setShowVersionModal(true);
  };

  return (
    <div>
      <VersionNotification onVersionClick={handleVersionClick} />
      <VersioningComponent
        isOpen={showVersionModal}
        onClose={() => setShowVersionModal(false)}
      />
      <NavigationBar />
      <div className="fbo-home-container">
        <div
          className="fbo-home-grid-container"
          style={{
            gridTemplateColumns: `repeat(${enabledFeeTypes.length}, 1fr)`,
          }}
        >
          {fboUserProfileData?.associations?.length === 0 && (
            <div className="association-remove-message">
              Your association has been removed by your Admin. Please contact
              your Admin for further details.
            </div>
          )}

          {enabledFeeTypes.includes("landingFee") && (
            <FeesCard
              title={"Landing Fees"}
              onClick={() => navigate(ROUTE_PATHS.LANDING_FEE_HOME)}
            />
          )}

          {enabledFeeTypes.includes("fuelRoyalty") && (
            <FeesCard
              title={"Fuel Royalty"}
              onClick={() => navigate(ROUTE_PATHS.FUEL_ROYALTY_HOME)}
            />
          )}

          {enabledFeeTypes.includes("landLease") && (
            <FeesCard
              title={"Airport Based Operators - ABOs"}
              onClick={() => navigate(ROUTE_PATHS.AIRPORT_BASED_OPERATORS_HOME)}
            />
          )}

          {hasAdminAccess && (
            <FeesCard
              title={"Account Maintenance"}
              onClick={() => navigate(ROUTE_PATHS.ACCOUNT_MAINTENANCE)}
            />
          )}
          {
            <FeesCard
              title={"Payments"}
              onClick={() => navigate(ROUTE_PATHS.PAYMENTS)}
            />
          }
        </div>
      </div>
      {SERVICE_URL.REACT_APP_VERSION && (
        <div className="fbo-home-version-container">
          <button
            onClick={() => setIsVersionDialogOpen(true)}
            className="version-button"
          >
            Version {SERVICE_URL.REACT_APP_VERSION}
          </button>
          <VersioningComponent
            isOpen={isVersionDialogOpen}
            onClose={() => setIsVersionDialogOpen(false)}
            version={SERVICE_URL.REACT_APP_VERSION}
          />
        </div>
      )}
    </div>
  );
};

export default FBOHome;
